import { render, staticRenderFns } from "./NotificationBoard.vue?vue&type=template&id=4ba38fdc&scoped=true"
import script from "./NotificationBoard.vue?vue&type=script&lang=js"
export * from "./NotificationBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba38fdc",
  null
  
)

export default component.exports